import React from 'react';
import { Link } from 'react-router-dom';
import { Home, User, Activity, Book, FileText, Video, Image, Newspaper, Mail, Users, FileText as File } from 'lucide-react';

const Sitemap = () => {
  const pages = [
    { title: 'होम', path: '/', icon: <Home className="w-5 h-5" /> },
    { title: 'परिचय', path: '/about', icon: <User className="w-5 h-5" /> },
    { title: 'कार्य', path: '/karya', icon: <Activity className="w-5 h-5" /> },
    { title: 'रचनाएँ', path: '/rachnaye', icon: <Book className="w-5 h-5" /> },
    { title: 'ब्लॉग', path: '/blog', icon: <FileText className="w-5 h-5" /> },
    { title: 'संपर्क', path: '/contact', icon: <Mail className="w-5 h-5" /> },
    { title: 'जॉइन करें', path: '/joinus', icon: <Users className="w-5 h-5" /> },
  ];

  const mediaPages = [
    { title: 'वीडियो', path: '/videos', icon: <Video className="w-5 h-5" /> },
    { title: 'गैलरी', path: '/gallery', icon: <Image className="w-5 h-5" /> },
    { title: 'प्रेस', path: '/press', icon: <Newspaper className="w-5 h-5" /> },
  ];

  const legalPages = [
    { title: 'गोपनीयता नीति', path: '/privacy-policy', icon: <File className="w-5 h-5" /> },
    { title: 'उपयोग की शर्तें', path: '/terms', icon: <File className="w-5 h-5" /> },
  ];

  const renderPageList = (title, pages) => (
    <div className="mb-8">
      <h3 className="text-xl font-bold text-orange-600 mb-4 flex items-center gap-2">
        {title}
      </h3>
      <ul className="space-y-2">
        {pages.map((page, index) => (
          <li key={index}>
            <Link 
              to={page.path} 
              className="flex items-center gap-2 text-gray-700 hover:text-orange-500 transition-colors"
            >
              {page.icon}
              {page.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">साइटमैप</h1>
          <p className="text-lg text-gray-600">वेबसाइट के सभी पेजों की सूची</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-md">
            {renderPageList('मुख्य पेज', pages)}
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-md">
            {renderPageList('मीडिया', mediaPages)}
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-md">
            {renderPageList('कानूनी', legalPages)}
          </div>
        </div>
        
        <div className="mt-12 text-center text-gray-500 text-sm">
          <p>© {new Date().getFullYear()} सीधी सोच सीधी बात. सर्व हक्क सुरक्षित.</p>
          <p className="mt-2">
            Design & Developed by{' '}
            <a 
              href="https://codevergeit.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-orange-500 hover:underline"
            >
              CodeVerge IT
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Sitemap;
